angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsLoadingCtrl", [
  "CustomerApplicationService", "$scope",
  (CustomerApplicationService, $scope) ->
    $scope.spinnerUrl = require('@amount/frontend-styles/src/images/dec/dec-loading.svg')
    CustomerApplicationService.goToStage('home')
]
